export default "__VITE_ASSET__Ch33hgUZ__"